import { useState } from "react";
import { useSelector } from "react-redux";

import { Grid, Box, makeStyles } from "@material-ui/core";

import { comparisonChartData } from "../sample";
import { COLORS } from "../../../../../theme/colors";
import { ShaDowBox } from "../../../../../components/boxes";
import { DEMO_ACCOUNT_EMAIL } from "../../../../../redux/auth";
import { profileGraphFooter, comparisonChartLines } from "../../../constants";
import { Progresses, LinearChartPart, NoDataCard } from "../../../../../components/parts";
import { ReactComponent as TenantImg } from "../../../../../assets/images/icons/tenant.svg";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
  },
  tenantImg: {
    fill: COLORS.white,
    "& path": {
      stroke: COLORS.white,
    },
    width: 11,
  },
  smallTenantImg: {
    fill: COLORS.white,
    "& path": {
      stroke: COLORS.white,
    },
    width: 7,
  },
}));

export const Risk = () => {
  const classes = useStyles();
  const { user } = useSelector((state) => state.auth);
  const showPlaceholder = user.email === DEMO_ACCOUNT_EMAIL;
  /* eslint-disable no-unused-vars */
  const [tenantRisk, setTenantRisk] = useState(showPlaceholder);
  const [consumptionVariation, setConsumptionVariation] = useState(showPlaceholder);
  const [paymentsHistory, setPaymentsHistory] = useState(showPlaceholder);
  const [paymentsSpeed, setPaymentsSpeed] = useState(showPlaceholder);
  const [personalCreditScore, setPersonalCreditScore] = useState(showPlaceholder);

  const tenantRiskTitle = "Tenant Risk";
  const consumptionVariationTitle = "Consumption variation";
  const paymentsHistoryTitle = "Payments History";
  const paymentsSpeedTitle = "Payments Speed";
  const personalCreditScoreTitle = "Personal Credit Score";

  return (
    <Grid container spacing={3}>
      <Grid item xs={8}>
        <ShaDowBox>
          {tenantRisk ? (
            <Box className={classes.root}>
              <Progresses
                showProgress={true}
                title={tenantRiskTitle}
                insideStyle={{ backgroundColor: COLORS.purple }}
                insideIcon={<TenantImg className={classes.tenantImg} />}
                outsideStyle={{ left: "calc(50% - 27px)" }}
                insideText="Moderate Risk"
                insideTextStyle={{ color: COLORS.maize }}
              />
            </Box>
          ) : (
            <NoDataCard title={tenantRiskTitle} withShaDowBox={false} />
          )}
          {consumptionVariation ? (
            <LinearChartPart
              titleStyle={{ marginBottom: 20, marginLeft: 32 }}
              title={consumptionVariationTitle}
              chartData={comparisonChartData}
              chartLines={comparisonChartLines}
              graphFooterItems={profileGraphFooter}
            />
          ) : (
            <NoDataCard
              title={consumptionVariationTitle}
              type="line"
              withShaDowBox={false}
              footerNames={["This Tenant", "Avg. building", "Avg. portfolio", "Avg. Industry"]}
            />
          )}
        </ShaDowBox>
      </Grid>
      <Grid item xs={4}>
        <ShaDowBox fullHeight>
          <Box style={{ padding: "40px 36px" }}>
            {paymentsHistory ? (
              <Progresses
                size="small"
                boxStyle={{
                  padding: 0,
                  backgroundColor: COLORS.white,
                }}
                title={paymentsHistoryTitle}
                insideIcon={<TenantImg className={classes.smallTenantImg} />}
                mainPointLeft={50}
                insideText="50%"
                points={[
                  { type: "building", left: 30 },
                  { type: "portfolio", left: 50 },
                  { type: "industry", left: 70 },
                ]}
              />
            ) : (
              <NoDataCard
                title={paymentsHistoryTitle}
                withShaDowBox={false}
                boxStyle={{ padding: 0 }}
                gridStyle={{ height: 105 }}
                iconStyle={{ height: 75 }}
              />
            )}
            {paymentsSpeed ? (
              <Progresses
                size="small"
                boxStyle={{
                  padding: "40px 0 0",
                  backgroundColor: COLORS.white,
                }}
                title={paymentsSpeedTitle}
                insideIcon={<TenantImg className={classes.smallTenantImg} />}
                mainPointLeft={96}
                insideText="96%"
                points={[
                  { type: "building", left: 30 },
                  { type: "portfolio", left: 50 },
                  { type: "industry", left: 70 },
                ]}
              />
            ) : (
              <NoDataCard
                title={paymentsSpeedTitle}
                withShaDowBox={false}
                boxStyle={{ padding: "40px 0 0" }}
                gridStyle={{ height: 105 }}
                iconStyle={{ height: 75 }}
              />
            )}
            {personalCreditScore ? (
              <Progresses
                size="small"
                boxStyle={{
                  padding: "40px 0 0",
                  backgroundColor: COLORS.white,
                }}
                title={personalCreditScoreTitle}
                insideIcon={<TenantImg className={classes.smallTenantImg} />}
                mainPointLeft={83}
                insideText="83%"
                points={[
                  { type: "building", left: 30 },
                  { type: "portfolio", left: 50 },
                  { type: "industry", left: 70 },
                ]}
              />
            ) : (
              <NoDataCard
                title={personalCreditScoreTitle}
                withShaDowBox={false}
                boxStyle={{ padding: "40px 0 0" }}
                gridStyle={{ height: 105 }}
                iconStyle={{ height: 75 }}
              />
            )}
          </Box>
        </ShaDowBox>
      </Grid>
    </Grid>
  );
};
